import { Injectable } from '@angular/core';
import {CanActivate, Router} from '@angular/router';
import {AuthService} from './shared/services/auth.service';
import {Observable} from 'rxjs/Observable';
import {tap} from 'rxjs/operators';
import { of } from 'rxjs';

@Injectable()
export class AuthGuard implements CanActivate {

  constructor(private authService: AuthService,
    private router: Router) {
  }

  canActivate() {
    return of(this.authService.isAuthenticated).pipe(
      tap(authenticated => {
        // console.log('authentication check');
        if (!authenticated) {
          this.router.navigate(['/auth/login']);
        }
      }),
    );
  }
}
